// Founder decision, 24 Oct 2026: staff PINs are 4 digits, and typing a PIN on
// a shared computer picks the person. The server tests it against this
// computer's people only; if two match, the person taps their name.
export const PIN_LENGTH = 4;

export const PIN_PATTERN = `[0-9]{${PIN_LENGTH}}`;

export function isPin(value: string): boolean {
  return new RegExp(`^${PIN_PATTERN}$`).test(value);
}

// Only digits, never longer than a PIN.
export function pinInput(value: string): string {
  return value.replace(/\D/g, "").slice(0, PIN_LENGTH);
}

// The server's rule (QuickPinSchema): no four of a kind and no straight run
// up or down. Same wording as its errors.
export function pinProblem(value: string): string | null {
  if (!isPin(value)) return "PIN must be exactly 4 digits";
  const digits = [...value].map(Number);
  const steps = digits.slice(1).map((digit, index) => digit - digits[index]!);
  const predictable =
    steps.every((step) => step === 0) ||
    steps.every((step) => step === 1) ||
    steps.every((step) => step === -1);
  return predictable ? "Choose a less predictable PIN" : null;
}
